import React, { useState } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-black/90 backdrop-blur-sm fixed top-0 w-full z-50 border-b border-yellow-500/20">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="https://www.kitco.com" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
            <img 
              src="https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/w77kfm85_Mining-Logo.svg" 
              alt="Kitco Mining" 
              className="h-8"
              onError={(e) => {
                // Fallback if SVG fails to load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="hidden items-center space-x-2">
              <div className="bg-yellow-500 text-black px-3 py-1 font-bold text-lg rounded">
                KITCO
              </div>
              <span className="text-yellow-500 font-semibold text-sm">MINING</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#services" className="text-white hover:text-yellow-500 transition-colors">
              Services
            </a>
            <a href="#audiences" className="text-white hover:text-yellow-500 transition-colors">
              Audiences
            </a>
            <a href="#clients" className="text-white hover:text-yellow-500 transition-colors">
              Clients
            </a>
            <Button 
              className="bg-yellow-500 hover:bg-yellow-400 text-black font-semibold px-6"
              onClick={() => {
                document.getElementById('contact')?.scrollIntoView({ 
                  behavior: 'smooth' 
                });
              }}
            >
              Contact Us
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-yellow-500/20">
            <div className="flex flex-col space-y-4 pt-4">
              <a href="#services" className="text-white hover:text-yellow-500 transition-colors">
                Services
              </a>
              <a href="#audiences" className="text-white hover:text-yellow-500 transition-colors">
                Audiences
              </a>
              <a href="#clients" className="text-white hover:text-yellow-500 transition-colors">
                Clients
              </a>
              <Button 
                className="bg-yellow-500 hover:bg-yellow-400 text-black font-semibold w-fit"
                onClick={() => {
                  document.getElementById('contact')?.scrollIntoView({ 
                    behavior: 'smooth' 
                  });
                }}
              >
                Contact Us
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;